import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  HintModule,
  NguAccordionModule,
  NguDataTableModule,
  NguFormsModule,
  TabsModule,
  NguDatePickerModule
} from '../extras';
import { NguModalModule } from '../extras/ngu-modal';;
import { MyDatePickerModule } from 'mydatepicker';
import { commonsComponents } from '../commons';
import { RolePermissionDirective } from './auth';
import { AuthGuard, DefaultRouteGuard, RoleGuard } from './guards';
import { FileValueDirective, NguFileDirective } from './ngu-file';
import { MySharedPipes } from './pipes';
import { ngValidations } from './validations';
import { BlockCopyPasteDirective } from './validations/blockcopypaste.directive';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { FoucsModelDirective } from './validations/foucs-model.directive';
import { PreventKeysDirective } from './validations/prevent-keys.directive';
import { TwoDigitDecimalNumberDirective } from './validations/two-digit-decimal-number.directive';


@NgModule({
  imports: [CommonModule],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NguDataTableModule,
    commonsComponents,
    ngValidations,
    FileValueDirective,
    NguFileDirective,
    NguModalModule,
    MyDatePickerModule,
    TabsModule,
    NguAccordionModule,
    MySharedPipes,
    RolePermissionDirective,
    HintModule,
    NguFormsModule,
    NguDatePickerModule,
    BlockCopyPasteDirective,
    TableModule,
    PaginatorModule
  ],
  declarations: [
    commonsComponents,
    ngValidations,
    FileValueDirective,
    NguFileDirective,
    MySharedPipes,
    RolePermissionDirective,
    BlockCopyPasteDirective,
    FoucsModelDirective,
    PreventKeysDirective,
    TwoDigitDecimalNumberDirective,        
  ]
})
export class SharedModule { }
